<!-- eslint-disable vue/html-self-closing -->
<template>
  <div>
    <h4>Past Links</h4>
    <div v-for="pastLink in pastLinks" :key="pastLink.signup_token" class="well">

      <div class="row">
        <div class="col-sm-2">
          <div class="form-group">
            <p class="control-label">Link Status</p>
            <p>Expired</p>
          </div>
        </div>

        <div class="col-sm-10">
          <div class="form-group">
            <p class="control-label">Signup Token</p>
            <div class="input-group">
              <a class="form-control  overflow-wrap">
                {{ pastLink.signup_token }}
              </a>
              <span class="input-group-btn">
                <button class="btn btn-default token-copy" :data-clipboard-text="pastLink.signup_token" type="button">Copy Token</button>
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-4">
          <div class="form-group">
            <p class="control-label">
              Link Activation Date *
            </p>
            <p>
              {{ new Date(pastLink.activation_date).toLocaleString() }} {{ timezoneAbbrev }}
            </p>
          </div>

          <div>
            <p class="control-label">
              Link Expiration Date *
            </p>
            <p>
              {{ new Date(pastLink.expiration_date).toLocaleString() }} {{ timezoneAbbrev }}
            </p>
          </div>

          <div class="form-group">
            <p class="control-label"> License End Date</p>
            <p>
              {{ pastLink.license_end_date }}
            </p>
          </div>
        </div>

        <div class="col-sm-4">
          <div class="form-group">
            <p class="control-label">
              Link Total Capacity
            </p>
            <p>
              {{ pastLink.total_capacity }}
            </p>
          </div>

          <div class="form-group">
            <p class="control-label">Link Used Capacity</p>
            <p>{{ pastLink.used_capacity }}</p>
          </div>

          <div class="form-group">
            <p class="control-label">Link Remaining Capacity</p>
            <p>{{ pastLink.remaining_capacity }}</p>
          </div>
        </div>

        <div class="col-sm-4">
          <div class="form-group">
            <p class="control-label">Link Notes</p>
            <p>
              <pre class="notes">{{ pastLink.notes || '(none)' }}</pre>
            </p>
          </div>
        </div>
      </div>
      <p>
        <i>
          {{ timezoneMessage }}
        </i>
      </p>
    </div>
  </div>
</template>

<script>
import Clipboard from 'clipboard'

export default {
  name: 'SignupLinksPast',
  props: {
    pastLinks: {
      type: Array,
      required: false,
      default: []
    },
    timezoneAbbrev: {
      type: String,
      required: true
    },
    timezoneMessage: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      clipboard: null
    }
  },
  created() {
    this.clipboard = new Clipboard(`.token-copy`)
  },
  beforeDestroy() {
    if (this.clipboard) {
      this.clipboard.destroy()
    }
  }
}
</script>

<style scoped>
.control-label {
  font-weight: 700;
}
.overflow-wrap {
  overflow-wrap: anywhere;
  height: fit-content;
}
.notes {
  border: none;
  font-family: "Roboto", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 14px;
}
</style>
